module.exports = {"110119001":"百泉街道","110119002":"香水园街道","110119003":"儒林街道","110119100":"延庆镇","110119101":"康庄镇","110119102":"八达岭镇","110119103":"永宁镇","110119104":"旧县镇","110119105":"张山营镇","110119106":"四海镇","110119107":"千家店镇","110119108":"沈家营镇","110119109":"大榆树镇","110119110":"井庄镇","110119200":"大庄科乡","110119201":"刘斌堡乡","110119202":"香营乡","110119203":"珍珠泉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110119.json
// module id = 37
// module chunks = 0